<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
        <div class="lg:mb-2">
          <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('historical.fechaEvento')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.from')}}
                          <el-form-item prop="fechaDesde">
                            <el-date-picker
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaDesde.value"
                              type="date"
                              format="dd-MM-yyyy"
                              :picker-options="dateRangeOptions"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaAltaD"
                              @blur="onBlurDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaAltaD-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaAltaD-popover"
                              >
                            </el-date-picker>
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.to')}}
                        <el-form-item prop="fechaHasta">
                          <el-date-picker
                            class="bg-white"
                            v-model="form.fechaHasta.value"
                            type="date"
                            format="dd-MM-yyyy"
                            :picker-options="dateRangeOptions"
                            placeholder="dd-mm-aaaa"
                            ref="datePickerFechaAltaH"
                            @blur="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @focus="onBlurDatePickerMixin('.datePickerFechaAltaH-popover')"
                            @keydown.native="captureKeyNotChrome"
                            popper-class="datePickerFechaAltaH-popover"
                            >
                          </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <div>
              <AccessibleElSelect
                v-model="form.eventoMultiple.value"
                prop="evento"
                :options="valuesTiposEventoForAccessibleSelect"
                :isMultiple="true"
                id-prefix="historicalgroupfilter"
              >
                <template slot="label">{{$t('historical.evento')}}</template>
              </AccessibleElSelect>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('historical.info')}}
                <el-form-item prop="mensaje">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.mensaje.value"
                    maxlength="500"
                  />
                </el-form-item>
              </label>
            </div>
            <div v-if="!this.isRoleUserOrConsulta">
              <AccessibleElSelect
                v-model="form.usuario.value"
                prop="usuario"
                :options="usersForAccessibleSelect"
                id-prefix="historicalgroupfilter"
              >
                <template slot="label">{{$t('historical.user')}}</template>
              </AccessibleElSelect>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import moment from 'moment'
import { getHistoricalEvents } from '@/services/historical/getHistoricalEvents'
import { getAllUsers } from '@/services/configurations/getAllUsers'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'trashHistoricalGroups',
      isOpen: this.panelOpen,
      form: {
        eventoMultiple: { label: 'Nombre del evento', value: '' },
        mensaje: { label: 'Información adicional', value: '' },
        usuario: { label: i18n.t('historical.user'), value: '' },
        fechaDesde: { label: 'Fecha desde', value: '' },
        fechaHasta: { label: 'Fecha hasta', value: '' }
      },
      users: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      valuesTiposEvento: []
    }
  },
  
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    valuesTiposEventoForAccessibleSelect: function () {
      return this.valuesTiposEvento.map(item => ({
        id: item.value,
        name: item.label,
        value: item.value
      }))
    },
    usersForAccessibleSelect: function () {
      return this.users.map(item => ({
        id: item.id,
        name: item.value,
        value: item.value
      }))
    }
  },
  mounted: async function () {
    const tipoEvento = { tipo: 'grupo' }
    const data = await getHistoricalEvents(tipoEvento)
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    }
    if (data.listaEventos.length > 0) {
      data.listaEventos.forEach(element => {
        this.valuesTiposEvento.push({ value: element, label: element.replaceAll('_', ' ') })
      })
    }

    if (!this.isRoleUserOrConsulta) {
      const dataUsers = await getAllUsers()
      if (dataUsers.blnError === true) {
        this.doFeedback(dataUsers.msgError + ' [Código de error: ' + dataUsers.codError + ']')
      } else {
        dataUsers.respuesta.forEach(row => {
          this.users.push({ id: row.IdUsuario, value: row.Usuario })
        })
      }
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    cleanMultiples: function () {
      if (Array.isArray(this.form.eventoMultiple.value) && this.form.eventoMultiple.value.length === 0) {
        this.form.eventoMultiple.value = ''
      }
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.eventoMultiple.value = _temp.eventoMultiple !== undefined && _temp.eventoMultiple ? _temp.eventoMultiple.value : ''
        this.form.mensaje.value = _temp.mensaje !== undefined && _temp.mensaje ? _temp.mensaje.value : ''
        this.form.usuario.value = _temp.usuario !== undefined && _temp.usuario ? _temp.usuario.value : ''
        this.form.fechaDesde.value = _temp.fechaDesde !== undefined && _temp.fechaDesde ? _temp.fechaDesde.value : ''
        this.form.fechaHasta.value = _temp.fechaHasta !== undefined && _temp.fechaHasta ? _temp.fechaHasta.value : ''
      }
      // console.log('_temp =>', _temp)
      // console.log('form =>', this.form)
    },
    watchFormHandler: function ({ fechaDesde, fechaHasta, evento }) {
      if (fechaDesde.value !== undefined && moment(fechaDesde.value).isValid()) {
        this.form.fechaDesde.value = moment(fechaDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaDesde.value = ''
      }

      if (fechaHasta.value !== undefined && moment(fechaHasta.value).isValid()) {
        this.form.fechaHasta.value = moment(fechaHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaHasta.value = ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        eventoMultiple: { label: 'Nombre del evento', value: '' },
        mensaje: { label: i18n.t('historical.info'), value: '' },
        usuario: { label: i18n.t('historical.user'), value: '' },
        fechaDesde: { label: i18n.t('historical.fechaDesde'), value: '' },
        fechaHasta: { label: i18n.t('historical.fechaHasta'), value: '' }
      }
    },
    applyFilters: function () {
      this.cleanMultiples()
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    },
  }
}
</script>

<style lang="scss" scoped></style>
